import { reportService } from "../_services/report.service";

export const report = {
  namespaced: true,
  state: {
    report: {},
    reports: {},
    startDownload: false
  },
  getters: {
    getReport: state => {
      return state.report;
    },
    getReports: state => {
      return state.reports;
    },
    getReportSelected: state => img => {
      return state.reports.filter(element => {
        return element.slug == img.slug;
      });
    },
    getStartDownload: state => {
      return state.startDownload;
    }
  },
  mutations: {
    setReport(state, newReport) {
      state.report = newReport;
    },
    setReports(state, reports) {
      state.reports = reports;
    },
    deleteReport(state, uuid) {
      let index = state.reports.findIndex(item => item.uuid === uuid);
      if (index !== -1) {
        state.reports.splice(index, 1);
      }
    },
    setStartDownload(state, status) {
      state.startDownload = status;
    }
  },
  actions: {
    getReportBASIC: ({ dispatch, commit }, uuid)  => new Promise((res, rej) => {
      reportService
        .getReportBASIC(uuid)
        .then(report => {
          commit("setReport", report);
          res(report);
        })
        .catch(error => {
          // commit("loginFailure", error);
          dispatch("alert/error", error, { root: true });
          rej(error);
        });
    }),
    getReportAOI: ({ dispatch, commit }, uuid) => new Promise((res, rej) =>  {
      reportService
        .getReportAOI(uuid)
        .then(report => {
          commit("setReport", report);
          res(report);
        })
        .catch(error => {
          // commit("loginFailure", error);
          dispatch("alert/error", error, { root: true });
          rej(error);
        });
    }),
    async postReport({ dispatch, commit }, data) {
      await reportService
        .postReport(data)
        .then(report => {
          commit("setReport", report);
        })
        .catch(error => {
          // commit("loginFailure", error);
          dispatch("alert/error", error, { root: true });
        });
    },

    async getReports({ dispatch, commit, getters }) {
      
      
      await reportService
        .getReports()
        .then(reports => {
          commit("setReports", reports.results);
        })
        .catch(error => {
          commit("loginFailure", error);
          dispatch("alert/error", error), { root: true };
        });
    },
    deleteReport({ dispatch, commit, getters }, uuid) {
      reportService
        .deleteReport(uuid)
        .then(report => {
          
          commit("deleteReport", uuid);
        })
        .catch(error => {
          commit("loginFailure", error);
          dispatch("alert/error", error, { root: true });
        });
    },
    deleteAOIReport: (context, uuid) => new Promise((res, rej) => {
      reportService.deleteAOIReport(uuid)
      .then(report => {
        res();
        context.dispatch('image/getImages',null, {root: true});
      })
      .catch(error => {
        rej(error);
        console.error(error);
      })
    }),
    updateSaliencyName: (context, [uuid, newName]) => new Promise((res, rej) => {
      reportService.updateSaliencyName(uuid, newName)
      .then(report => {
        res();
      })
      .catch(error => {
        rej(error)
        console.error(error);
      })
    })
  }
};
